import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Alert} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { API, BASE_URL } from '../../CONST';
import DownloadBtn from '../shared/DownloadBtn';
import FileUploader from '../shared/FileUploader';

const OperacionesLiquidacionCredito = () => {
  const [intermediarios, setIntermediarios] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleValidationSuccess = (validationResponse) => {
    const found = validationResponse?.datos?.intermediarios || [];
    setIntermediarios(found);
    setSelectedIds(found.map((i) => i.id));
  };

  const toggleIntermediario = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  return (
    <div className="container-fluid py-3">

      <Row className="g-3">
        {/* --- CARGA FACTURAS LIQUIDACION CREDITO --- */}
        <Col lg="4" md="6">
          <Card className="shadow-sm h-100 border-0">
            <CardBody className="text-center d-flex flex-column justify-content-between">
              <div>
                <FontAwesomeIcon icon={faFileInvoice} size="2x" className="text-primary mb-3" />
                <h6 className="fw-bold mb-3 text-dark">Carga de Comisiones</h6>
                <p className="text-muted small mb-3">
                  Sube comisiones de liquidaciones. Se asociarán automáticamente según el contenido del archivo.
                </p>

                <Alert color="info" className="mb-1 small">
                  <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                  El archivo será validado antes de la carga. Verás los resultados en una ventana emergente.
                </Alert>
                <div className="mb-2"></div>

                <FileUploader
                  type="button"
                  preUploadUrl={`${BASE_URL}${API.liquidacion}/validate/`}
                  uploadUrl={`${BASE_URL}${API.liquidacion}/bulk_upload_facturas/`}
                  inputId="factura-bulk-uploader"
                  accept=".xlsx"
                  stateData={{ id: 1 }}
                  maxFileSize={10485760}
                  confirmButtonText="Confirmar subida"
                  showMontosTable={false}
                  enableValidationModal
                  onValidationSuccess={handleValidationSuccess}
                  extraUploadFields={{
                    notify_intermediario_ids: JSON.stringify(selectedIds),
                  }}
                />

                {intermediarios.length > 0 && (
                  <div className="text-start mt-3">
                    <p className="small fw-bold mb-2">Notificar por email a:</p>
                    {intermediarios.map((i) => (
                      <div key={i.id} className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`notify-${i.id}`}
                          checked={selectedIds.includes(i.id)}
                          onChange={() => toggleIntermediario(i.id)}
                        />
                        <label className="form-check-label small" htmlFor={`notify-${i.id}`}>
                          {i.nombre} ({i.rut})
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div style={{ gridColumnStart: 2 , marginTop: 5}}>
                <DownloadBtn
                  id="xlsx-download"
                  text="Template"
                  tipText="Descargar Template Excel"
                  url={`${BASE_URL}${API.liquidacion}/download_xlsx_template/`}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default OperacionesLiquidacionCredito;